/**
 * A watchdog for the one failure a phone cannot recover from on its own: a
 * dialog, sheet or drawer that locked page scrolling and then unmounted
 * without putting it back. The page then looks frozen — nothing scrolls,
 * nothing responds — and the only way out is a reload.
 *
 * So: whenever no dialog is actually open, any leftover scroll lock on the
 * body is cleared. Cheap, and it runs on every route change plus a slow tick.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const OPEN_OVERLAY = '[role="dialog"][data-state="open"], [data-state="open"][data-radix-popper-content-wrapper], [role="alertdialog"][data-state="open"]';

const release = () => {
  if (document.querySelector(OPEN_OVERLAY)) return;
  const body = document.body;
  const locked = body.hasAttribute('data-scroll-locked')
    || body.style.position === 'fixed'
    || body.style.overflow === 'hidden'
    || body.style.touchAction === 'none';
  if (!locked) return;
  body.removeAttribute('data-scroll-locked');
  ['position', 'overflow', 'overflowY', 'touchAction', 'top', 'left', 'right', 'width', 'paddingRight']
    .forEach((prop) => { body.style[prop] = ''; });
};

export default function MobileTouchUnlock() {
  const location = useLocation();
  useEffect(() => {
    release();
    const timer = setInterval(release, 3000);
    return () => clearInterval(timer);
  }, [location.pathname]);
  return null;
}
